<template>
    <o-table :title="$t('sandoz.reports')" ref="tableList" url="/api/sandoz/reports?per_page=30" :enable-new="false"
             :enable-delete="false" :enable-edit="false">
        <template slot="filter">
          <o-filter v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :filter-cacheable="false">
            <o-filter-text :title="$t('sandoz.name')" column="name"></o-filter-text>
          </o-filter>
        </template>
        <template slot="head">
            <o-table-header column="name">{{$t('sandoz.name')}}</o-table-header>
        </template>
        <template slot="body" slot-scope="props">
            <td>{{ props.item.name }}</td>
        </template>
        <template slot="head-controls">
            <th></th>
        </template>
        <template slot="body-controls" slot-scope="props">
            <td class="text-right">
                <o-button type="button" class="btn-sm" @click="favouriteReport(props.item.id)" v-if="!props.item.favourite_id">
                    <fa icon="star"/>
                </o-button>


                <fa-layers class="fa-stack fa-1x cursor-pointer" @click="removefavouriteReport(props.item.favourite_id)" v-if="props.item.favourite_id">
                    <fa :icon="['fas', 'star']" style="color: #0061AB;"/>
                    <fa :icon="['fas', 'ban']" style="color: red;" class="fa-stack-2x"/>
                </fa-layers>
                <o-button type="button" class="btn-sm" :loading="queueing.includes(props.item.id)" @click="queueReport(props.item.id)" v-tooltip="$t('sandoz.queue_report_tooltip')">
                    <fa icon="envelope"/>
                </o-button>
                <o-button type="button" class="btn-sm" :loading="loading.includes(props.item.id)" @click="downloadReport(props.item.id)">
                    <fa icon="arrow-right"/>
                </o-button>
            </td>
        </template>
    </o-table>
</template>


<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'

  export default {
    data: () => ({
      loading: [],
      queueing: [],
      favourites: []
    }),
    computed: {
      ...mapGetters({
        user: 'auth/user'
      }),
    },
    methods: {
      downloadReport(id) {
        this.loading.push(id)
        const headers = {
          'accept': 'application/vnd.ms-excel'
        }

        axios({
          method: 'GET',
          url: '/api/sandoz/reports/' + id,
          responseType: 'blob',
          headers: headers
        }).then((response) => {
          var filename = 'report.xlsx'
          var contentDisposition = response.headers['content-disposition']
          if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
            var matches = filenameRegex.exec(contentDisposition)
            if (matches != null && matches[1]) {
              filename = matches[1].replace(/['"]/g, '')
              filename = filename.replace(/%20/g," ")
            }
          }

          require('downloadjs')(response.data, filename, headers.accept)
          this.loading = []
        })
          .catch((err) => {
            this.$notify({
              title: this.$i18n.t('core.error'),
              text: this.$i18n.t('core.error_text', {error: err}),
              type: 'error'
            })

            this.loading = []
          })

      },
      queueReport(id) {
        this.queueing.push(id)
        axios.post('/api/sandoz/reports/' + id + '/queue')
          .then((response) => {
            this.$notify({
              text: this.$i18n.t('sandoz.report_queued_success'),
              type: 'success'
            })
            this.queueing = this.queueing.filter(item => item !== id)
          })
          .catch((err) => {
            this.$notify({
              title: this.$i18n.t('core.error'),
              text: this.$i18n.t('core.error_text', {error: err}),
              type: 'error'
            })
            this.queueing = this.queueing.filter(item => item !== id)
          })
      },
      favouriteReport(id) {

        var data = {
          id: null,
          report_id: id,
          user_id: this.user.id
        }
        axios.post('/api/system/report_favourites/new', data)
          .then((response) => {
            this.$notify({
              text: this.$i18n.t('sandoz.excel_fav_added')
            })

            this.$refs.tableList.search()
          }).catch((error) => {
            this.$notify({
              text: this.$i18n.t('sandoz.error_excel_fav_added'),
              type: 'error'
            })
        })
      },
      removefavouriteReport(id) {
        axios.delete('/api/system/report_favourites/' + id)
          .then((response) => {
            this.$notify({
              text: this.$i18n.t('sandoz.excel_fav_removed'),
            })
            this.$refs.tableList.search()
          }).catch((error) => {
            this.$notify({
              text: this.$i18n.t('sandoz.error_excel_fav_removed'),
              type: 'error'
            })
        })
      }
    }
  }
</script>
